<app-portal></app-portal>

    <div class="body">

        <div class="content">

            <form [formGroup]="form">

                <p class="p-titulo-form"> Dados Gerais </p>

                <mat-divider></mat-divider>

                <div class="grid grid--auto-fill">

                    <mat-form-field>
                        <mat-label>Nome</mat-label>
                        <input appTitlecase formControlName="nome" matInput >
                        <mat-error>Informação necessária</mat-error>
                    </mat-form-field>

                    <mat-form-field style="pointer-events: none;">
                        <mat-label>E-mail</mat-label>
                        <input formControlName="email" id="idEmail" matInput appLowwercase ngModel email autocomplete="on">
                        <mat-error>E-mail Incorreto, por favor corrigir.</mat-error>
                    </mat-form-field>

                    <mat-form-field style="pointer-events: none;">
                        <mat-label>CPF</mat-label>
                        <input formControlName="cpf" [mask]="cpfMask" matInput>
                        <!-- <mat-error *ngIf="form.get('cpf').hasError('cpfInvalido')">CPF inválido</mat-error>
                        <mat-error *ngIf="form.get('cpf').hasError('required')">Informação necessária</mat-error> -->
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Telefone</mat-label>
                        <input formControlName="telefoneFixo" [mask]="maskTelefoneFixoPrincipal" matInput>
                        <mat-error>Informação necessária</mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Sexo</mat-label>
                        <mat-select formControlName="sexo">
                            <mat-option [value]="1"> Masculino  </mat-option>
                            <mat-option [value]="2"> Feminino  </mat-option>
                            <mat-option [value]="3"> Outros  </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Data de nascimento</mat-label>
                        <input formControlName="dataNascimento" matInput [max]="today" [matDatepicker]="picker">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker startView="multi-year"></mat-datepicker>
                    </mat-form-field>

                </div>

                <p class="p-titulo-form">Aqui Você Poderá Cadastrar a Sua Chave Pix.</p>

                <mat-divider></mat-divider>

                <div formGroupName="pix" class="grid grid--auto-fill">

                    <mat-form-field>
                        <mat-label>Qual o tipo de chave PIX?</mat-label>
                        <mat-select formControlName="tipoChavePix">
                            <mat-option [value]="1"> CPF ou CNPJ </mat-option>
                            <mat-option [value]="1"> Número de celular </mat-option>
                            <mat-option [value]="1"> E-mail </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Digite a sua chave PIX</mat-label>
                        <input appTitlecase formControlName="chavePix" matInput >
                        <mat-error>Informação necessária</mat-error>
                    </mat-form-field>

                </div>
                
                <div class="div-atencao">
                    <p class="p-atencao">* Atenção: A chave Pix deverá ser sua, a transferência não será realizada para contas de terceiros.</p>
                </div>

                <p class="p-titulo-form"> Endereço </p>

                <mat-divider></mat-divider>

                <div formGroupName="endereco" class="grid grid--auto-fill">

                    <mat-form-field>
                        <mat-label>CEP</mat-label>
                        <input formControlName="cep" [mask]="maskCep" matInput>
                        <mat-error>Informação necessária</mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Rua</mat-label>
                        <input formControlName="rua" matInput appTitlecase>
                        <mat-error>Informação necessária</mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Número</mat-label>
                        <input formControlName="numero" matInput>
                        <mat-error>Informação necessária</mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Complemento</mat-label>
                        <input formControlName="complemento" matInput appTitlecase>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Bairro</mat-label>
                        <input formControlName="bairro" matInput appTitlecase>
                        <mat-error>Informação necessária</mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Cidade</mat-label>
                        <input formControlName="cidade" matInput appTitlecase>
                        <mat-error>Informação necessária</mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Estado</mat-label>
                        <mat-select formControlName="estado">
                            <mat-option *ngFor="let estado of estados" [value]="estado">
                                {{ estado }}
                            </mat-option>
                        </mat-select>
                        <mat-error>Informação necessária</mat-error>
                    </mat-form-field>

                </div>

                <div class="div-botoes">
                    <button mat-raised-button class="b-voltar" (click)="goToHome()"> Voltar </button>
                    <button mat-raised-button color="primary"> Salvar </button>
                </div>

            </form>

        </div>

    </div>

<app-compartilhe></app-compartilhe>